// extracted by mini-css-extract-plugin
module.exports = {"lineLoader":"LineLoader_lineLoader__pf67_","box-1":"LineLoader_box-1__dkSga","box-2":"LineLoader_box-2__5rfOy"};